import { toast } from "sonner";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const deviceId = () => {
  let d = localStorage.getItem("itz_device");
  if (!d) { d = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, ""); localStorage.setItem("itz_device", d); }
  return d;
};

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => { try { cfg.headers["X-Device-Id"] = deviceId(); } catch (e) { /* storage blocked */ } return cfg; });

const _toastErr = toast.error;
toast.error = (msg, ...rest) => (typeof msg === "string" && msg.startsWith("🔒") ? null : _toastErr(msg, ...rest));

let refreshing = null;
api.interceptors.response.use(
  (r) => {
    const amount = Number(r.headers?.["x-points-awarded"] || 0);
    if (amount > 0) window.dispatchEvent(new CustomEvent("points-awarded", { detail: { amount, reason: decodeURIComponent(r.headers["x-points-reason"] || "") } }));
    return r;
  },
  async (error) => {
    const cfg = error.config;
    const det = error.response?.data?.detail;
    if (error.response?.status === 403 && typeof det === "string" && det.startsWith("🔒")) window.dispatchEvent(new CustomEvent("invite-gate", { detail: det }));
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const imgSrc = (p) => (p && p.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p);

export const fmtDate = (s) =>
  new Date(s).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
